import Screen from './Screen';
import { withConfig } from '../../Contexts/ConfigContext';

export default withConfig(Screen);
